import { useContext, useState } from 'react'
import { CompanyConfigContext } from '../../context api/Configuration/CompanyConfig'
import { useRestApi } from '../../lib/RestApi/useRestApi'
import { API_URL } from '../../shared/actions'

export const useModuleAdmins = () => {
  const [moduleAdmin, setModuleAdmin] = useState(false)
  const { deleteNewModuleAdmin, getNewModuleAdmins } = useContext(CompanyConfigContext)
  const [loading, setLoading] = useState(false)
  const [paginate, setPaginate] = useState(false)

  const { ADD, GET_ALL, UPDATE, GET_SINGLE_DATA, DELETE } = useRestApi(setLoading, 'ModuleAdmins', 'ALL_MODULEADMINS', 'GET_ALL_MODULEADMINS')
  const {
    MODULEADMIN: { GET_ALL_MODULEADMINS, ADD_MODULEADMIN, EDIT_MODULEADMIN, GET_MODULEADMIN, DELETE_MODULEADMIN },
  } = API_URL

  const getAllModuleAdmins = async (dto = {}) => {
    GET_ALL(GET_ALL_MODULEADMINS, setPaginate, getNewModuleAdmins, dto)
  }

  const addModuleAdmin = (dto) => {
    ADD(ADD_MODULEADMIN, dto)
  }

  const updateModuleAdmin = (dto) => {
    UPDATE(EDIT_MODULEADMIN, dto)
  }

  const getModuleAdmin = (dto) => {
    GET_SINGLE_DATA(GET_MODULEADMIN, setModuleAdmin, dto)
  }

  const deleteManyModuleAdmin = (dto, setSelected = () => {}) => {
    DELETE(DELETE_MODULEADMIN, dto, 'moduleAdminId', setSelected, deleteNewModuleAdmin, 'GET_ALL_MODULEADMINS')
  }

  return {
    addModuleAdmin,
    getAllModuleAdmins,
    getModuleAdmin,
    moduleAdmin,
    updateModuleAdmin,
    deleteManyModuleAdmin,
    loading,
    paginate,
  }
}
